import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {ApiService, ConfigService} from '../../shared';
import {ZonaExclusion} from '../models';

@Injectable({
  providedIn: 'root'
})
export class ZonaExclusionService extends ApiService<ZonaExclusion> {
  protected dataKey = 'zonasExclusion';
  protected objectKey = 'ZonasDeExclusion';
  protected sendObjectKey = 'zonasExclusion';
  protected sendObjectIdsKey = 'zonasDeExclusionIds';
  protected reciveObjectKey = 'zonaExclusion';


  constructor(protected httpClient: HttpClient) {
    super(ZonaExclusion, httpClient);
  }

   /**
   * Return url from method.
   * @param method to url.
   * @param addObject agregar el objectKey al final.
   */
    protected getUrl(method: string, addObject = false): string {
      let baseApiUrl = ConfigService.get(this.urlKey);
      let partialURL = `${method}${this.objectKey}`;

      if(method === 'query'){
        partialURL = 'queryZonasExclusion';
      }
      if(method === 'delete'){
        baseApiUrl = ConfigService.get('apiSeguroUrl');
      }
      return `${baseApiUrl}/${partialURL}`;
    }
}
